import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { getIconPath } from '../../Functions/GetIconPath';
import { saveToLocalStorage } from '../../Functions/LocalStorageUtils';
import { setSelectingDevice, setShowAddDevicePopup } from '../../redux/reducers/appReducer';
import { useAppDispatch } from '../../redux/store';
import Button from '../Button/Button';

import styles from './AddDevicePopup.module.scss';

const AddDevicePopup: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const handleNeverShowAgain = () => {
        saveToLocalStorage('hideAddDevicePopup', 'true');
        dispatch(setShowAddDevicePopup(false));
        toast.info(t('addDevicePopup.dontShowAgainToast'));
    }

    return (
        <>
            <div className={styles.AddDevicePopup}>
                <div className={styles.AddDevicePopup__wrapper}>
                    <img src={getIconPath('arrow_back')} onClick={() => dispatch(setShowAddDevicePopup(false))} className={styles.AddDevicePopup__back} />
                    <h2>{t('addDevicePopup.title')}</h2>
                    <p>{t('addDevicePopup.description')}</p>
                    <div className={styles.AddDevicePopup__buttons}>
                        <Button variant='fill' size='sm' onClick={() => {dispatch(setSelectingDevice(true)); dispatch(setShowAddDevicePopup(false)); }}>{t('addDevicePopup.addButton')}</Button>
                        <Button variant='fill' size='lg' onClick={() => dispatch(setShowAddDevicePopup(false))}>{t('addDevicePopup.rejectButton')}</Button>
                    </div>
                    <Button variant="light" size="lg" onClick={() => handleNeverShowAgain()}>{t('addDevicePopup.dontShowAgain')}</Button>
                </div>
            </div>
        </>
    )
}

export default AddDevicePopup;